import React, { useEffect, useState } from 'react';
import { Container } from '../Components/ui/container';
import { Inline } from '../Components/ui/layout';
import { Button } from '../Components/ui/button';
import { getApiUrl } from '../config/api';

const LightHeader = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    window.location.href = '/';
  };

  return (
    <header className="sticky top-0 z-sticky bg-background border-b border-border shadow-sm">
      <Container size="full">
        <Inline justify="between" align="center" className="py-md">
          {/* Logo */}
          <img
            className="h-10 w-auto cursor-pointer"
            src="/Newzenalphablue.png"
            alt="SearchJobAI Logo"
            onClick={() => (window.location.href = '/')}
          />

          {/* Navigation */}
          <nav className="hidden md:block">
            <Inline spacing="lg" as="ul" className="list-none">
              <li>
                <a
                  href="/jobpage"
                  className="text-foreground hover:text-primary transition-colors duration-fast font-medium"
                >
                  Jobs
                </a>
              </li>
              <li>
                <a
                  href="/explore"
                  className="text-foreground hover:text-primary transition-colors duration-fast font-medium"
                >
                  Explore
                </a>
              </li>
              <li>
                <a
                  href="/trends"
                  className="text-foreground hover:text-primary transition-colors duration-fast font-medium"
                >
                  Trends
                </a>
              </li>
              <li>
                <a
                  href="#category"
                  className="text-foreground hover:text-primary transition-colors duration-fast font-medium"
                >
                  Category
                </a>
              </li>
            </Inline>
          </nav>

          {/* CTA Buttons */}
          <Inline spacing="sm" align="center">
            <Button
              variant="secondary"
              onClick={() => (window.location.href = '/hirewithus')}
            >
              Hire with US
            </Button>

            {isLoggedIn ? (
              <Button variant="outline" onClick={handleLogout}>
                Logout
              </Button>
            ) : (
              <>
                <Button
                  variant="outline"
                  onClick={() => (window.location.href = getApiUrl('/login_user'))}
                >
                  Login
                </Button>
                <Button
                  variant="default"
                  onClick={() => (window.location.href = getApiUrl('/signin_user'))}
                >
                  Join now
                </Button>
              </>
            )}
          </Inline>
        </Inline>
      </Container>
    </header>
  );
};

export default LightHeader;
